import { createContext, useContext } from 'react';
import type { Community } from '@/types';

interface CommunityContextType {
  community: Community;
  isLoading: boolean;
  isError: unknown;
}

export const CommunityContext = createContext<CommunityContextType | undefined>(undefined);

export function useCommunityContext() {
  const context = useContext(CommunityContext);
  if (context === undefined) {
    throw new Error('useCommunityContext must be used within a CommunityProvider');
  }
  return context;
}
